module.exports = __webpack_public_path__ + "static/media/exe.35efd548.svg";